export enum Locale {
    DE_DE = "de-DE",
    DE_CH = "de-CH"
}

export const FALLBACK_LOCALE = Locale.DE_DE;